import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { BehaviorSubject, interval } from 'rxjs';
import { debounce, map, takeUntil } from 'rxjs/operators';
import { ClientObject, Permission, Profile } from './master-bo-perfil-acesso.model';
import { MasterBoPerfilAcessoService } from './services/master-bo-perfil-acesso.service';

@Component({
  selector: 'app-master-bo-perfil-acesso',
  templateUrl: './master-bo-perfil-acesso.component.html',
  styleUrls: ['./master-bo-perfil-acesso.component.scss']
})

export class MasterBoPerfilAcessoComponent extends AppScreenBase implements OnInit {

  profiles: any;
  filterAutoComplete: any;
  userFilter: any;
  clientStatus = true;
  dataAccordion: object;
  name: any;
  sortedData: any;
  permissionDados: Permissions[];
  isAsc = true;
  count: any;
  profileList: any[];
  indexChoice: number = 0;
  perfilSelected: string;
  dialogConfig: MatDialogConfig;
  clientList: any[];
  lastProfileCreatedId: string;
  clientIdsConcatenated: any[];
  panelOpenState;
  movementPermissions:any
  positionPermissions:any
  otherReportPermissions:any
  reportPermission:any
  public SELECTED = "selected";

  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  @Output() onProfileCreated: EventEmitter<any> = new EventEmitter<any>();
  @Input() form: FormGroup;
  @Input() email: FormGroup;
  @Input() clientIds$: BehaviorSubject<ClientObject[]>;
  hasRelatoriosPermissionSelected: boolean = false;
  
  constructor(private repository: MasterBoPerfilAcessoService) { super();}

  protected onClose(): void { }

  ngOnInit() {
     this.updateProfiles();
    
  }

  private async updateProfiles() {
    console.log(this.email)
    this.profileList = await this.repository.getIds([{id:this.email.get('login').value}]);
    const desiredOrder = ['Permissões de sistema', 'Permissões de operação', 'Permissões de relatório',"Relatorios"];
    this.profileList.forEach(profile => {
      if (profile.permissionGroups) {
        profile.permissionGroups.sort((a, b) => {
          const indexA = desiredOrder.indexOf(a.name);
          const indexB = desiredOrder.indexOf(b.name);
          return indexA - indexB;
        });
      }
    })
    let radioGroup = this.form.get('profileId');
    if (this.profileList && this.profileList.length > 0) {

      // HACK
      // radioGroup.setValue(radioGroup.value || this.profileList[0].id);
      radioGroup.setValue(this.SELECTED);

      this.profileList.forEach((profileTypes) => {
        let permissionGroups = profileTypes?.permissionGroups;
        if(permissionGroups && permissionGroups.length > 0) {
          permissionGroups.forEach(permissionGroup => {
            if(permissionGroup.name =='Relatorios'){
              this.movementPermissions = permissionGroup.permissions.filter(p => p.name?.startsWith('MOVEMENT'));
              this.positionPermissions = permissionGroup.permissions.filter(p => p.name?.startsWith('POSICAO') || p.name?.startsWith('POSITION'));
              this.otherReportPermissions = permissionGroup.permissions.filter(p => p.name?.startsWith('OTHER'));
            }
            if(permissionGroup.name =='Permissões de relatório'){
              this.reportPermission = permissionGroup.permissions.filter(p => p.name ==='Relatórios');
              }
          });
        }
       
      })
    }
    this.updateProfileFormValue();
    this.checkInitialRelatoriosSelection();
  }

  updateRadioProfile(i) {
    this.indexChoice = i;
  }

  proxyAutoComplete(term = null) {
    if (!term) return;
    const complete = this.profiles.map((client) => {
      return client.permissionGroupProfiles.filter((prof) => {
        return prof.profile != undefined
      }).map((pro) => {
        return pro.profile
      })
    })
    this.filterAutoComplete = [].concat(...complete).filter((ele) => ele.toLowerCase().includes(term.toLowerCase()))
  }

  getSelectedPermissionsLength(permissions: Permission[] = []) {
    return permissions.filter((item) => item.checked == true).length;
  }

  updateProfileFormValue(){
    if (this.profileList && this.profileList.length > 0) {

      let index = this.profileList.findIndex((item, i) => {
        return item.id == this.form.get('profileId').value;
      });

      if (!index || index < 0) index = 0;
      const profileFormControl = this.form.get('permissionGroups');
      if (profileFormControl) profileFormControl.setValue(this.profileList[index]);
    }
  }
  sumReportsSelected(arr1,arr2,arr3) {
    let combinedReportsArray = [...(arr1 || []), ...(arr2 || []), ...(arr3 || [])];
    let len = combinedReportsArray.length
    let numSelected = 0;
    if (combinedReportsArray !== null) {
      combinedReportsArray.forEach(elemeent => {
        if (JSON.parse(elemeent.checked) === true) {
          numSelected++;
        }
      });
    }
    let str = numSelected + "/"+len
    return str
  }
  onRelatoriosToggled(isChecked: boolean) {
    this.hasRelatoriosPermissionSelected = isChecked;

    if (!isChecked) {
      // Uncheck all report permissions when "Relatorios" is unchecked
      this.movementPermissions?.forEach(p => p.checked = false);
      this.positionPermissions?.forEach(p => p.checked = false);
      this.otherReportPermissions?.forEach(p => p.checked = false);
    }
  }
  validateCheckedItems(): boolean {
    let isValid : boolean =false 
    const movementsValid = this.movementPermissions?.some(p => p.checked) ?? false;
    const positionsValid = this.positionPermissions?.some(p => p.checked) ?? false;
    const reportsValid = this.otherReportPermissions?.some(p => p.checked) ?? false;
    const reportPermission = this.reportPermission?.some(p => p.checked) ?? false;
    if(!reportPermission || (reportPermission && (movementsValid || positionsValid || reportsValid))){
      isValid =true
    } else{
      isValid=false
    }

    return isValid
  }

  checkInitialRelatoriosSelection() {
    const relatoriosPermission = this.profileList[this.indexChoice]?.permissionGroups
      .find(pg => pg.name === "Permissões de relatório")?.permissions
      .find(p => p.name === 'Relatórios');
    
    this.hasRelatoriosPermissionSelected = relatoriosPermission?.checked || false;
  }
}
